import React from 'react';

import styles from './GetStartedHeader.module.scss';
import { useTranslation } from 'react-i18next';

interface GetStartedHeaderProps {
  name?: string;
  group?: string;
  currentStep?: number;
  totalSteps?: number;
}

export const GetStartedHeader: React.FC<GetStartedHeaderProps> = ({
  name = 'your',
  group = 'this group',
  currentStep = '1',
  totalSteps = '1',
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <span className={styles.title}>{t('group-get-started.header.title', { name, group })}</span>
      <span className={styles.pagination}>
        {t('group-get-started.header.pagination', { currentStep, totalSteps })}
      </span>
    </div>
  );
};
